import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c50ef6ba")

_pushScopeId("data-v-c50ef6ba")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_3 = { class: "spin" }
const _hoisted_4 = { class: "page" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Featured Classes")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "video-info" }
const _hoisted_8 = { class: "text-primary" }
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = { style: {"font-size":"65%"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_navbar = _resolveComponent("navbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_fab = _resolveComponent("ion-fab")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_badge = _resolveComponent("ion-badge")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_bottombar = _resolveComponent("bottombar")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          _createVNode(_component_navbar)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_fab, {
        vertical: "bottom",
        horizontal: "center",
        class: ["centerme", { marginbottom: !_ctx.isWeb }]
      }, {
        default: _withId(() => [
          (!_ctx.toggleFilter)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 0,
                color: "light",
                shape: "round",
                onClick: _cache[1] || (_cache[1] = () => _ctx.openFilterModal())
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, {
                    size: "small",
                    icon: _ctx.filterCircleOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _hoisted_1
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.toggleFilter)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 1,
                color: "primary",
                shape: "round",
                onClick: _cache[2] || (_cache[2] = () => _ctx.openFilterModal())
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, {
                    size: "small",
                    icon: _ctx.filterCircleOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _hoisted_2
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]),
      (_ctx.classesLoading)
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 0,
            fullscreen: true
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_ion_spinner, { name: "crescent" })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.classesLoading)
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 1,
            fullscreen: true
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_ion_grid, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withId(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredClasses, (featuredClass, index) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            key: featuredClass.name + index,
                            size: "12",
                            "size-lg": "3",
                            "size-md": "4",
                            "size-sm": "12"
                          }, {
                            default: _withId(() => [
                              (_ctx.isAuth)
                                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                                    (_ctx.isBookmarked(featuredClass))
                                      ? (_openBlock(), _createBlock(_component_ion_button, {
                                          key: 0,
                                          class: "bookmarkBtn",
                                          fill: "clear",
                                          onClick: ($event: any) => (_ctx.removeBookmark(featuredClass))
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_ion_icon, {
                                              icon: _ctx.bookmark,
                                              color: "light"
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : (_openBlock(), _createBlock(_component_ion_button, {
                                          key: 1,
                                          class: "bookmarkBtn",
                                          fill: "clear",
                                          onClick: ($event: any) => (_ctx.addBookmark(featuredClass))
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_ion_icon, {
                                              color: "light",
                                              icon: _ctx.bookmarkOutline
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_card, {
                                class: "category-card",
                                button: "",
                                onClick: ($event: any) => (_ctx.openModal(featuredClass))
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_badge, {
                                    color: "primary",
                                    class: "class-badge"
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(featuredClass.isLive ? "LIVE" : "On Demand"), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_img, {
                                    src: featuredClass?.imgURL
                                  }, null, 8, ["src"]),
                                  _createVNode("div", _hoisted_7, [
                                    _createVNode("b", _hoisted_8, _toDisplayString(featuredClass.name), 1),
                                    _hoisted_9,
                                    _createVNode("span", _hoisted_10, _toDisplayString(featuredClass.trainerData.name), 1),
                                    _createVNode("span", _hoisted_11, _toDisplayString(" " + featuredClass.duration + " Minute Workout"), 1),
                                    (_ctx.hasProgressed(featuredClass))
                                      ? (_openBlock(), _createBlock(_component_ion_badge, {
                                          key: 0,
                                          color: "light",
                                          class: "class-watched"
                                        }, {
                                          default: _withId(() => [
                                            _createTextVNode(_toDisplayString(_ctx.progressType(featuredClass.classID)), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_bottombar)
    ]),
    _: 1
  }))
})